import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { MotionPathPlugin } from 'gsap/dist/MotionPathPlugin';

gsap.registerPlugin(
  ScrollTrigger,
  // ScrollToPlugin,
  MotionPathPlugin,
);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.MotionPathPlugin = MotionPathPlugin;

$(document).ready(function () {
  if ($('.show-opacity').length) {
    gsap.set(".show-opacity", { opacity: 0 });
    ScrollTrigger.batch(".show-opacity", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { opacity: 1, stagger: 0.3 });
      },
    });
  }
  if ($('.show-zoom-in').length) {
    gsap.set(".show-zoom-in", { opacity: 0 , scale: 0.8});
    ScrollTrigger.batch(".show-zoom-in", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { ease: 'power1.inOut', opacity: 1, scale: 1, stagger: 0.3 });
      },
    });
  }
  if ($('.show-zoom-in-fast').length) {
    gsap.set(".show-zoom-in-fast", { opacity: 0 , scale: 0.6});
    ScrollTrigger.batch(".show-zoom-in-fast", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { ease: 'power1.inOut', opacity: 1, scale: 1, stagger: 0.1 });
      },
    });
  }
  if ($('.show-in-top').length) {
    gsap.set(".show-in-top", { opacity: 0, y: -30 });
    ScrollTrigger.batch(".show-in-top", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { ease: 'back.out(1.5)', opacity: 1, y: 0, stagger: 0.6 });
      },
    });
  }
  if ($('.show-to-top').length) {
    gsap.set(".show-to-top", { y: 50, opacity: 0 });
    ScrollTrigger.batch(".show-to-top", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { opacity: 1, y: 0, stagger: 0.1 });
      },
    });
  }

  if ($('.show-in-left').length) {
    gsap.set(".show-in-left", { x: -10, opacity: 0 });
    ScrollTrigger.batch(".show-in-left", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { opacity: 1, x: 0, stagger: 0.1 });
      },
    });
  }

  if ($('.show-in').length) {
    gsap.set(".show-in", { });
    ScrollTrigger.batch(".show-in", {
      onEnter: function onEnter(batch) {
        batch.forEach(el => el.classList.add("animate"));
        gsap.to(batch, {stagger: 0.3 });
      },
    });
  }


  // banner
  if ($('.page-banner').length >= 1) {
    gsap.to(".bn-line", {
      duration: 2.5,
      y: -13,
      x: 7,
      opacity: 0.3,
      yoyo: true,
      repeat: -1,
      ease: "none",
      stagger: {
        grid: [14, 4],
        from: "edges",
        amount: 2
      }
    });

    gsap.to(".line-spot", {
      motionPath: {
        path: [{ x: 0, y: 0, opacity: 0.9, scale: 1 }, { x: 60, y: -30, opacity: 1, scale: 1.1 }, { x: 100, y: 20, opacity: 1, scale: 1.2 }, { x: 30, y: 50, opacity: 0.8, scale: 1 }, { x: -5, y: 0, opacity: 1, scale: 1.2 }, { x: 0, y: 0, opacity: 0.9, scale: 1 }],
      },
      stagger: 0.25,
      duration: 7,
      ease: "power1.inOut",
      repeat: -1,
    });

    gsap.to(".line-spot-2", {
      motionPath: {
        path: [{ x: 0, y: 0, opacity: 0.9, scale: 1 }, { x: -60, y: 80, opacity: 1, scale: 1.3 }, { x: -100, y: 20, opacity: 0.8, scale: 1 }, { x: 100, y: -80, opacity: 1, scale: 1.5 }, { x: 150, y: -30, opacity: 1, scale: 1 }],
      },
      stagger: 0.25,
      duration: 10,
      yoyo: true,
      repeat: -1,
    });

    let spots = document.querySelectorAll(".bn-spot");
    let spotCount = spots.length;
    spots.forEach((spot, index) => {
      let spot_id = spot.id;
      // 隨機生成 path_id (1-62 之間的整數)
      let path_id = Math.floor(Math.random() * 62) + 1;

      // 隨機生成 duration (11-16 之間的數值)
      let duration = Math.random() * 6 + 11;

      // 隨機生成 repeatDelay (0-3 之間的數值)
      let repeatDelay = Math.random() * 3;

      // 根據元素索引計算基本延遲，確保在整個 0-2 秒範圍內均勻分布
      let baseDelay = (index / spotCount) * 2;

      // 添加一點隨機性，但保持在較小範圍內 (+/- 0.3 秒)
      let randomOffset = (Math.random() - 0.5) * 0.6;

      // 最終的延遲時間，確保在 0-2 秒範圍內
      let delay = Math.max(0, Math.min(2, baseDelay + randomOffset));

      gsap.to(`#${spot_id}`, {
        motionPath: {
          path: `#bn_line_${path_id}`,
          align: `#bn_line_${path_id}`,
          autoRotate: true,
          alignOrigin: [0.5, 0.5]
        },
        duration: duration,
        ease: "none",
        repeat: -1,
        repeatDelay: repeatDelay,
        delay: delay,
      });
    });

  };

  // time line
  if ($('.timeLine').length >= 1) {
    let items = document.querySelectorAll(".timeLine-item");
    let images = document.querySelectorAll(".timeLine-img");
    let timeLineOffset = $('.timeLine').offset().top;

    function showImage(id) {
      images.forEach(img => img.classList.remove("active"));
      $('#timeLine_img' + id).addClass("active");
    }

    items.forEach((item, index) => {
      ScrollTrigger.create({
        trigger: item,
        start: `top ${timeLineOffset + 16}px`,
        end: "bottom center",
        onEnter: () => {
          item.classList.add("is-active");
          showImage(index);
          if (index > 0) {
            items[index - 1].classList.add("end");
          }
        },
        onLeaveBack: () => {
          item.classList.remove("is-active");
          showImage(index - 1);
          if (index > 0) {
            items[index - 1].classList.remove("end");
          }
        }
      });
    });
  }

});
